


import axios from "axios";

const API_URL = "https://backend.maamaas.com/promotions/api/user/create/campaign";
const BILLING_API = "https://backend.maamaas.com/promotions/api/user/get/billing";


export const createCampaign = async (payload, file) => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing — please login again");

    const form = new FormData();

    const jsonBlob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    form.append("campaign", jsonBlob, "campaign.json");

    // ✅ File is optional — only append if provided
    if (file) {
        form.append("creative", file, file.name);
    }



    const response = await axios.post(API_URL, form, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (e) => {
            // console.log("📤 Upload progress:", e.loaded, "of", e.total, "bytes");
        }
    });


    return response;
};

export const getBillingConfig = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing");

    const response = await axios.get(
        "https://backend.maamaas.com/promotions/api/user/get/billing",
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};


export const getVendorDetails = async (vendorId) => {
    const token = localStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `https://backend.maamaas.com/subscription/api/admin/get/enquiry/${vendorId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("❌ FULL ERROR:", error);

        if (error.response) {


        } else {
            console.error("❌ Network error / server not reachable");
        }

        throw error;
    }
};

export const getScreens = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing");

    const response = await axios.get(
        "https://backend.maamaas.com/promotions/api/user/screens",
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};